import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { vars } from '../../theme';
import { THtmlTextTag, TTextAlignment, TWeight } from '../HBText/HBText.types';
import { TCustomFont, customFont } from '../../styles/fonts';

export interface Props {
    color?: string;
    /** Font family name; resolved against the customFont registry first, then used as-is with ProximaNova fallback. */
    fontFamily?: TCustomFont;
    className?: string;
    align?: TTextAlignment;
    fontSize?: string;
    weight?: TWeight;
    children?: ReactNode;
    /** HTML element to render; defaults to 'span'. */
    tag?: THtmlTextTag;
    lineHeight?: string;
}

type StyleProps = {
    $color: Props['color'];
    $fontFamily: Props['fontFamily'];
    $align: Props['align'];
    $fontSize: Props['fontSize'];
    $weight: Props['weight'];
    $lineHeight: Props['lineHeight'];
};

const Text = styled.span<StyleProps>`
    ${({ $align, $weight }) => css`
        ${$align &&
        css`
            text-align: ${$align};
        `}
        ${$weight &&
        css`
            font-weight: ${$weight};
        `}
    `}
    color: ${props => props.$color};
    font-family: ${props =>
        customFont[props.$fontFamily]?.font_family ||
        `${props.$fontFamily}, 'ProximaNova'`};
    font-size: ${props => props.$fontSize};
    line-height: ${props => props.$lineHeight};
`;

const HBCustomText = ({
    tag = 'span',
    children,
    className,
    align,
    weight = '400',
    color = vars.colors.text.primary,
    // Keep 'ProximaNova' default for backward compatibility with user-customizable themes
    fontFamily = 'ProximaNova',
    fontSize = '16px',
    lineHeight = '1.3'
}: Props) => {
    return (
        <Text
            as={tag}
            className={className}
            $align={align}
            $weight={weight}
            $color={color}
            $fontFamily={fontFamily}
            $fontSize={fontSize}
            $lineHeight={lineHeight}
        >
            {children}
        </Text>
    );
};

export default HBCustomText;
